import { render } from "./BaseMultiValue.vue?vue&type=template&id=2f3b7a46"
import script from "./BaseMultiValue.vue?vue&type=script&lang=js"
export * from "./BaseMultiValue.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__